<template>
  <v-list id="dashboard-menu">
    <MainMenuEntry
      v-for="entry in entries"
      :key="entry.location.name"
      :icon-name="entry.iconName"
      :text="entry.text"
      :location="entry.location"
    />
  </v-list>
</template>

<script setup lang="ts">
import MainMenuEntry from '@/components/navigation/MainMenuEntry.vue'
import { i18n } from '@/lang/setup'

import { adminRouteName } from '../app'

const entries = [
  {
    iconName: 'mdi-domain',
    location: { name: adminRouteName('organisation-list') },
    text: i18n.global.t('models.core.organisation.prettyName', 2),
  },
  {
    iconName: 'mdi-account',
    location: { name: adminRouteName('profile-root') },
    text: i18n.global.t('models.core.user.prettyName', 2),
  },
  {
    iconName: 'mdi-google-circles-communities',
    location: { name: adminRouteName('role-root') },
    text: i18n.global.t('models.core.role.prettyName', 2),
  },
  {
    iconName: 'mdi-account-group',
    location: { name: adminRouteName('group-root') },
    text: i18n.global.t('models.core.group.prettyName', 2),
  },
  {
    iconName: 'mdi-lock-outline',
    location: { name: adminRouteName('object-authorization-root') },
    text: i18n.global.t('models.core.objectauthorization.prettyName', 2),
  },
  {
    iconName: 'mdi-puzzle',
    location: { name: adminRouteName('client-app-root') },
    text: i18n.global.t('models.client.clientapp.prettyName', 2),
  },
]
</script>
